export default "__VITE_ASSET__CEorHn15__"